import { RootState } from '@/app/model/store';

export const selectDraggedSliceID = (state: RootState) =>
  state.slices.draggedSliceID;
